export default __webpack_public_path__ + "static/media/13.eb1d7fc0.png";